export enum MachineryFlagsEnum {
  METROLOGY_MACHINES = 'metrologyMachines',
  BAR_FEEDER = 'barFeeder',
}
